<template>
    <div class="container mt-4">
        <h4 class="mb-3">Privacidade e Conta</h4>
        <p class="text-muted">
            Gerencie seus dados e sua conta no aplicativo.
        </p>

        <div class="row mt-4">

            <!-- CARD: EXCLUIR DADOS -->
            <div class="col-md-6 mb-4">
                <div class="card h-100 border">
                    <div class="card-body d-flex flex-column">
                        <h5 class="card-title">Excluir dados do app</h5>

                        <p class="text-muted small">
                            Remove dados relacionados ao seu acesso e uso do aplicativo.
                            Isso não exclui seu cadastro profissional nas empresas.
                        </p>

                        <ul class="small text-muted pl-3">
                            <li>Remove seus dados de login</li>
                            <li>Encerra sessões ativas</li>
                            <li>Remove dispositivos vinculados</li>
                        </ul>

                        <div class="mt-auto">
                            <button class="btn btn-outline-danger btn-block" @click="abrirModal('dados')">
                                Excluir meus dados
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- CARD: EXCLUIR CONTA -->
            <div class="col-md-6 mb-4">
                <div class="card h-100 border-danger">
                    <div class="card-body d-flex flex-column">
                        <h5 class="card-title text-danger">Excluir conta</h5>

                        <p class="text-muted small">
                            Encerra sua conta de acesso ao aplicativo.
                            Você não poderá mais entrar com esta conta.
                        </p>

                        <ul class="small text-muted pl-3">
                            <li>Conta será desativada</li>
                            <li>Acesso ao app será bloqueado</li>
                            <li>Histórico pode ser mantido para fins operacionais</li>
                        </ul>

                        <div class="mt-auto">
                            <button class="btn btn-danger btn-block" @click="abrirModal('conta')">
                                Excluir minha conta
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- MODAL CONFIRMAÇÃO -->
        <div class="modal fade" tabindex="-1" role="dialog" ref="modalConfirmacao">
            <div class="modal-dialog" role="document">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ tipoAcao === 'dados' ? 'Excluir dados do app' : 'Excluir conta' }}
                        </h5>
                        <button type="button" class="close" @click="fecharModal">
                            <span>&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <p v-if="tipoAcao === 'dados'">
                            Tem certeza que deseja excluir seus dados do aplicativo?
                        </p>

                        <p v-if="tipoAcao === 'conta'">
                            Esta ação irá desativar sua conta. Você não conseguirá mais acessar o sistema.
                        </p>

                        <!-- Confirmação extra para conta -->
                        <div v-if="tipoAcao === 'conta'" class="mt-3">
                            <label class="small">
                                Digite <strong>EXCLUIR</strong> para confirmar:
                            </label>
                            <input type="text" class="form-control" v-model="confirmacaoTexto" />
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button class="btn btn-secondary" @click="fecharModal">
                            Cancelar
                        </button>

                        <button class="btn" :class="tipoAcao === 'dados' ? 'btn-outline-danger' : 'btn-danger'"
                            :disabled="tipoAcao === 'conta' && confirmacaoTexto !== 'EXCLUIR'" @click="confirmarAcao">
                            Confirmar
                        </button>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import appUtils from '@/composables/utils';
import 'bootstrap';
import $ from 'jquery';
import AgendaService from "../service/AgendaService";

export default {
    name: 'MinhaContaPrivacidade',

    data() {
        return {
            tipoAcao: null, // 'dados' ou 'conta'
            confirmacaoTexto: '',
            loading: false
        }
    },

    methods: {
        abrirModal(tipo) {
            this.tipoAcao = tipo
            this.confirmacaoTexto = ''
            $(this.$refs.modalConfirmacao).modal('show')
        },

        fecharModal() {
            $(this.$refs.modalConfirmacao).modal('hide')
        },

        async confirmarAcao() {
            if (this.loading) return
            this.loading = true
            const { toast } = appUtils(this)

            try {
                if (this.tipoAcao === 'dados') {

                    await AgendaService.excluirDadosMinhaConta()
                        .then((resposta) => {
                            let retorno = resposta.data;
                            if (retorno.status === "SUCCESS") {
                                toast(retorno.mensagens[0].descricao, 'Sucesso', 'success')
                                this.fecharModal()
                            } else {
                                toast(retorno.mensagens[0].descricao, 'Falha', 'danger')
                            }
                        }).catch((error) => {
                            toast(error, 'Falha', 'danger')
                        });

                    await this.$http.post('/api/app/minha-conta/excluir-dados')
                } else {
                    await AgendaService.excluirMinhaConta()
                        .then((resposta) => {
                            let retorno = resposta.data;
                            if (retorno.status === "SUCCESS") {
                                toast(retorno.mensagens[0].descricao, 'Sucesso', 'success')
                                this.fecharModal()

                                // 🔥 Se excluiu conta, já desloga                                            
                                this.$store.dispatch('auth/logout');

                                this.$router.push({
                                    path: '/login/acesso',
                                    query: { msg: 'conta_excluida' }
                                })

                            } else {
                                toast(retorno.mensagens[0].descricao, 'Falha', 'danger')
                            }

                        }).catch((error) => {
                            toast(error, 'Falha', 'danger')
                        });
                }

            } catch (e) {
                this.$toast.error('Erro ao realizar operação: ' + e)
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.card {
    border-radius: 8px;
}

.card-title {
    font-weight: 600;
}

button {
    font-weight: 500;
}
</style>